import Home from './Home';
import styles from './styles';
import withStyles from 'react-jss';
import { injectIntl } from 'react-intl';
var stylesHoc = withStyles(styles);
export default injectIntl(stylesHoc(Home));



//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/index.tsx
// module id = 1349
// module chunks = 0